import React from 'react';
import { translate } from 'admin-on-rest';
import { getFormValues, change as onChange } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  Card,
  CardHeader,
  List,
  ListItem,
  Divider,
  SelectField,
  MenuItem,
  CardText,
} from 'material-ui';
import ChipInput from 'material-ui-chip-input';
import { get, keys } from 'lodash';
import equal from 'deep-equal';

// eslint-disable-next-line no-shadow
class UserPermissionInput extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  shouldComponentUpdate = (nextProps) => !equal(this.props.record, nextProps.record) || (this.props.choices.venues && this.props.choices.venues.length !== nextProps.choices.venues.length) || (this.props.choices.roles && this.props.choices.roles.length !== nextProps.choices.roles.length);

  render() {
    // eslint-disable-next-line no-shadow
    const { translate, record, choices = {} } = this.props;

    const user = record;
    const permissions = get(user, 'permissions');
    const userVenues = keys(permissions);
    const { venues, roles } = choices;

    if (!venues || !roles) {
      return null;
    }
    console.log(roles);
    return (
      <div>
        <Card>
          <CardHeader title={translate('permissions')} />
          <Divider />
          <CardText>
            <ChipInput
              fullWidth
              openOnFocus
              dataSource={venues}
              dataSourceConfig={{ text: 'name', value: 'name' }}
              value={userVenues.map((venue) => ({ name: venue }))}
              floatingLabelText={translate('places')}
              onRequestAdd={({ name }) => {
                console.log(name);
                const newPermissions = { ...permissions, [name]: { role: '', position: '' } };
                this.props.change('record-form', 'permissions', newPermissions);
              }}
              onRequestDelete={(name) => {
                const newPermissions = { ...permissions };
                delete newPermissions[name];
                this.props.change('record-form', 'permissions', newPermissions);
              }}
            />
          </CardText>
          <List>
            {userVenues.map((venue) => (
              <ListItem
                key={venue}
                primaryText={venue}
                secondaryText={(permissions[venue].role || permissions[venue].position) && `${permissions[venue].role} ${permissions[venue].position}`}
                primaryTogglesNestedList
                style={{ borderBottom: '1px solid rgba(0,0,0,0.12)' }}
                nestedListStyle={{ border: '1px solid rgba(0,0,0,0.15)', borderWidth: '2px 8px 2px 8px', padding: '1em 1em' }}
                nestedItems={[
                  <SelectField
                    key={0}
                    fullWidth
                    floatingLabelText={translate('resources.users.fields.role')}
                    value={permissions[venue].role}
                    onChange={(e, i, val) => this.props.change('record-form', `permissions[${venue}].role`, val)}
                  >
                    {roles && roles.map((role) => (
                      <MenuItem key={role.id} primaryText={role.name} value={role.id} />
                    ))}
                  </SelectField>,
                  <ChipInput
                    key={1}
                    fullWidth
                    openOnFocus
                    dataSource={['franchisees', 'restaurantManager', 'steward', 'waiter', 'barManager', 'bartender', 'chef', 'sousChef', 'cook', 'dishwasher', 'prospect', 'socialMediaManager', 'areaManager', 'economy']}
                    defaultValue={permissions[venue].position}
                    floatingLabelText={translate('resources.users.fields.position')}
                    onChange={(val) => this.props.change('record-form', `permissions[${venue}].position`, val)}
                  />,
                ]}
              />
            ))}
          </List>
        </Card>
      </div>
    );
  }
}

const selector = getFormValues('record-form');

const enhance = compose(
  translate
);

export default connect((state) => ({ record: selector(state) }), { change: onChange })(enhance(UserPermissionInput));
